import { render, staticRenderFns } from "./teacherIndex.vue?vue&type=template&id=7221d346&"
import script from "./teacherIndex.vue?vue&type=script&lang=js&"
export * from "./teacherIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports